export default "__VITE_PUBLIC_ASSET__4e7a0c89__"